(function () {
  'use strict';

  var ALLOWED_EXTS  = ['.pdf', '.jpg', '.jpeg', '.png'];
  var ALLOWED_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];
  var submitting    = false; // prevent duplicate submit clicks

  function init() {
    var root = document.getElementById('gii-root');
    if (!root) return;

    var form      = document.getElementById('gilgal-insurance-form');
    var submitBtn = document.getElementById('gii-submit-btn');
    var successEl = document.getElementById('gii-success');
    var errorEl   = document.getElementById('gii-error');
    var maxBytes  = parseInt(root.dataset.maxMb || '10', 10) * 1024 * 1024;
    var endpoint  = (root.dataset.endpoint || '').trim();
    var apiKey    = (root.dataset.apiKey   || '').trim();

    if (!form) return;

    // ── Phone auto-format: (###) ###-#### ──────────────────────────────────
    var phoneInput = form.querySelector('input[name="phone"]');
    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        var fmt = formatPhone(phoneInput.value);
        if (fmt !== phoneInput.value) phoneInput.value = fmt;
      });
    }

    // ── "Other" reveal: insurance provider & product category ───────────────
    setupOtherReveal(
      form.querySelector('select[name="insurance_provider"]'),
      document.getElementById('gii-ins-provider-other-wrap')
    );
    setupOtherReveal(
      form.querySelector('select[name="product_category"]'),
      document.getElementById('gii-product-category-other-wrap')
    );

    // ── File input: show filename, validate on change ───────────────────────
    root.querySelectorAll('.gii-upload-box').forEach(function (box) {
      var input       = box.querySelector('input[type="file"]');
      var primaryText = box.querySelector('.gii-upload-text__primary');
      var defaultTxt  = primaryText ? primaryText.textContent : '';
      var item        = box.closest('.gii-upload-item');
      var uploadErr   = item ? item.querySelector('.gii-upload__error') : null;

      if (!input) return;

      input.addEventListener('change', function () {
        var file = input.files[0];
        clearUploadError(box, uploadErr);

        if (!file) {
          box.classList.remove('gii-upload-box--has-file', 'gii-upload-box--error');
          if (primaryText) primaryText.textContent = defaultTxt;
          return;
        }

        var err = fileError(file, maxBytes);
        if (err) {
          box.classList.add('gii-upload-box--error');
          box.classList.remove('gii-upload-box--has-file');
          showErr(uploadErr, err);
          input.value = '';
          if (primaryText) primaryText.textContent = defaultTxt;
        } else {
          box.classList.add('gii-upload-box--has-file');
          if (primaryText) primaryText.textContent = file.name;
        }
      });
    });

    // ── Submit ──────────────────────────────────────────────────────────────
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (submitting) return;                   // block duplicate clicks
      if (validate(root, maxBytes) > 0) return; // client-side validation
      if (!endpoint || !apiKey) return;          // safety guard

      submitting = true;
      errorEl.style.display = 'none';
      setLoading(submitBtn, true);

      var formData = new FormData(form);

      // Replace "Other" select values with the free-text field value
      resolveOther(form, formData, 'insurance_provider', 'insurance_provider_other');
      resolveOther(form, formData, 'product_category',   'product_category_other');

      fetch(endpoint, {
        method:  'POST',
        headers: { 'x-api-key': apiKey },
        // Do NOT set Content-Type — browser sets multipart/form-data with boundary automatically
        body:    formData,
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (result) {
          setLoading(submitBtn, false);
          submitting = false;

          if (result.ok && result.data && result.data.ok) {
            if (result.data.submission_number) {
              var bodyEl = successEl.querySelector('.gii-message__body');
              if (bodyEl) {
                bodyEl.textContent = bodyEl.textContent +
                  ' Your reference number is: ' + result.data.submission_number + '.';
              }
            }
            form.style.display = 'none';
            successEl.style.display = 'block';
            successEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            var serverMsg = (result.data && result.data.error) ? result.data.error : null;
            showServerError(errorEl, serverMsg);
            submitBtn.disabled = false;
          }
        })
        .catch(function () {
          setLoading(submitBtn, false);
          submitting = false;
          showServerError(errorEl, null);
          submitBtn.disabled = false;
        });
    });
  }

  // ── Phone formatting ───────────────────────────────────────────────────────

  function formatPhone(raw) {
    var digits = raw.replace(/\D/g, '').slice(0, 10);
    if (digits.length < 4) return digits;
    if (digits.length < 7) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
    return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
  }

  // ── "Other" reveal ─────────────────────────────────────────────────────────

  function setupOtherReveal(select, wrapEl) {
    if (!select || !wrapEl) return;
    function update() {
      var show  = select.value === 'Other';
      wrapEl.style.display = show ? '' : 'none';
      var input = wrapEl.querySelector('input, textarea');
      if (input) {
        if (show) {
          input.setAttribute('data-required', '');
          input.setAttribute('aria-required', 'true');
        } else {
          input.removeAttribute('data-required');
          input.removeAttribute('aria-required');
          input.value = '';
          clearFieldError(input, wrapEl.querySelector('.gii-field__error'));
        }
      }
    }
    select.addEventListener('change', update);
    update(); // run on init in case of pre-filled value
  }

  function resolveOther(form, formData, selectName, otherName) {
    var select = form.querySelector('select[name="' + selectName + '"]');
    if (!select || select.value !== 'Other') {
      formData.delete(otherName);
      return;
    }
    var otherInput = form.querySelector('[name="' + otherName + '"]');
    var otherVal   = otherInput ? otherInput.value.trim() : '';
    formData.set(selectName, otherVal || 'Other');
    formData.delete(otherName);
  }

  // ── Validation ─────────────────────────────────────────────────────────────

  function validate(root, maxBytes) {
    var errors = 0;

    // Required text / select / textarea (upload box divs excluded — validated below)
    root.querySelectorAll('input[data-required], select[data-required], textarea[data-required]').forEach(function (el) {
      var wrap  = el.closest('.gii-field');
      var errEl = wrap ? wrap.querySelector('.gii-field__error') : null;
      clearFieldError(el, errEl);
      var val = typeof el.value === 'string' ? el.value.trim() : '';
      if (!val) {
        setFieldError(el, errEl, el.dataset.errorMsg || 'This field is required.');
        errors++;
      }
    });

    // Format validators — only run if the field has a value and wasn't already flagged
    errors += runFormatCheck(root, 'dob',   validateDob);
    errors += runFormatCheck(root, 'phone', validatePhone);
    errors += runFormatCheck(root, 'email', validateEmail);
    errors += runFormatCheck(root, 'zip',   validateZip);

    // Consent checkbox
    var consent    = document.getElementById('gii-consent');
    var consentErr = document.getElementById('gii-consent-error');
    if (consent) {
      clearErr(consentErr);
      if (!consent.checked) {
        showErr(consentErr, 'You must provide consent to submit this request.');
        errors++;
      }
    }

    // Required file uploads
    root.querySelectorAll('.gii-upload-box[data-required]').forEach(function (box) {
      var input = box.querySelector('input[type="file"]');
      var item  = box.closest('.gii-upload-item');
      var errEl = item ? item.querySelector('.gii-upload__error') : null;
      clearUploadError(box, errEl);

      if (!input || !input.files || !input.files[0]) {
        box.classList.add('gii-upload-box--error');
        showErr(errEl, 'This file is required.');
        errors++;
        return;
      }
      var err = fileError(input.files[0], maxBytes);
      if (err) {
        box.classList.add('gii-upload-box--error');
        showErr(errEl, err);
        errors++;
      }
    });

    // Optional file uploads — validate if a file was chosen
    root.querySelectorAll('.gii-upload-box:not([data-required])').forEach(function (box) {
      var input = box.querySelector('input[type="file"]');
      if (!input || !input.files || !input.files[0]) return;
      var item  = box.closest('.gii-upload-item');
      var errEl = item ? item.querySelector('.gii-upload__error') : null;
      var err   = fileError(input.files[0], maxBytes);
      if (err) {
        box.classList.add('gii-upload-box--error');
        showErr(errEl, err);
        errors++;
      }
    });

    if (errors > 0) {
      var first = root.querySelector('[aria-invalid="true"], .gii-upload-box--error');
      if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    return errors;
  }

  // Run one format check for a named field; returns 1 if error, 0 if ok/skipped.
  function runFormatCheck(root, name, fn) {
    var el  = root.querySelector('[name="' + name + '"]');
    if (!el) return 0;
    var val = typeof el.value === 'string' ? el.value.trim() : '';
    if (!val) return 0; // blank already flagged by required check
    if (el.getAttribute('aria-invalid') === 'true') return 0; // already flagged
    var wrap  = el.closest('.gii-field');
    var errEl = wrap ? wrap.querySelector('.gii-field__error') : null;
    var err   = fn(val);
    if (err) { setFieldError(el, errEl, err); return 1; }
    return 0;
  }

  function validateDob(val) {
    var d = new Date(val);
    if (isNaN(d.getTime())) return 'Please enter a valid date of birth.';
    var now    = new Date();
    var maxAge = new Date(now.getFullYear() - 120, now.getMonth(), now.getDate());
    if (d > now)    return 'Date of birth cannot be in the future.';
    if (d < maxAge) return 'Please enter a valid date of birth (cannot be more than 120 years ago).';
    return null;
  }

  function validatePhone(val) {
    if (val.replace(/\D/g, '').length !== 10) return 'Please enter a valid 10-digit phone number.';
    return null;
  }

  function validateEmail(val) {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) return 'Please enter a valid email address.';
    return null;
  }

  function validateZip(val) {
    if (!/^\d{5}(-\d{4})?$/.test(val)) return 'Please enter a valid ZIP code (e.g. 33101 or 33101-1234).';
    return null;
  }

  function fileError(file, maxBytes) {
    var ext    = (file.name.match(/\.[^.]+$/) || [''])[0].toLowerCase();
    var okExt  = ALLOWED_EXTS.indexOf(ext) > -1;
    var okMime = ALLOWED_TYPES.indexOf(file.type) > -1;
    if (!okExt && !okMime) return 'Only PDF, JPG, JPEG, and PNG files are accepted.';
    if (file.size > maxBytes) return 'File exceeds ' + Math.round(maxBytes / 1048576) + 'MB limit.';
    return null;
  }

  // ── DOM helpers ────────────────────────────────────────────────────────────

  function setFieldError(el, errEl, msg) {
    el.setAttribute('aria-invalid', 'true');
    showErr(errEl, msg);
  }
  function clearFieldError(el, errEl) {
    el.removeAttribute('aria-invalid');
    clearErr(errEl);
  }
  function clearUploadError(box, errEl) {
    box.classList.remove('gii-upload-box--error');
    clearErr(errEl);
  }
  function showErr(el, msg)  { if (el) { el.textContent = msg; el.classList.add('gii-visible'); } }
  function clearErr(el)      { if (el) { el.textContent = '';  el.classList.remove('gii-visible'); } }

  function setLoading(btn, on) {
    btn.disabled = on;
    btn.classList.toggle('gii-submit-btn--loading', on);
    var txt = btn.querySelector('.gii-submit-btn__text');
    if (txt) txt.textContent = on ? 'Submitting…' : 'Submit Insurance Request';
  }

  function showServerError(errorEl, serverMsg) {
    if (serverMsg) {
      var bodyEl = errorEl.querySelector('.gii-message__body');
      if (bodyEl) bodyEl.textContent = serverMsg;
    }
    errorEl.style.display = 'block';
    errorEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ── Boot ───────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
